import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class StaffViewModel {
    ShowAlert:     (pTitle: string, pMessage: string)    => void;
    BackToSignIn:  ()                                    => void;
    NewLoading:    (pMessage: string)                    => dmLoading;
    ShowChangePIN: (pStaff: RQService.Tasks.GetStaffRow) => void;

    mlText:        MLText;
    app:           mlBroker;
    ml:            mlBroker;
    Hotel:         dmHotel;
    LangID:        number;

    NewStaffName:  string;
    NewPIN:        string;
    ConfirmNewPIN: string;

    Staff:         RQService.Tasks.GetStaffRow[];

    constructor(
         pMLText:        MLText
        ,pHotel:         dmHotel
        ,pBackToSignIn:  ()                                        => void
        ,pShowAlert:     (pTitle: string, pMessage: string)        => void
        ,pNewLoading:    (pMessage: string)                        => dmLoading
        ,pShowChangePIN: (pResHolder: RQService.Tasks.GetStaffRow) => void
    ) {
        this.mlText        = pMLText;
        this.LangID        = this.mlText.GetLangID();
        this.app           = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml            = this.mlText.GetBroker(
            'CTMExtranetStaff'
        );

        this.Hotel         = pHotel;
        this.BackToSignIn  = pBackToSignIn;
        this.ShowAlert     = pShowAlert;
        this.NewLoading    = pNewLoading;
        this.ShowChangePIN = pShowChangePIN;

        this.Staff         = [];

        this.NewStaffName  = '';
        this.NewPIN        = '';
        this.ConfirmNewPIN = '';

        this.refreshStaff();
    }

    private refreshStaff() {
        let staffParams = RQParam.TasksGetStaffParams();

        staffParams.HotelID = this.Hotel.HotelID;
        staffParams.LangID  = this.Hotel.LangID;

        let loading: dmLoading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        RQService.Tasks.GetStaff(staffParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) {
                loading.Dismiss();

                return;
            }

            let staffList = response.RQueryResult;

            this.Staff.length = 0;

            for (let i = 0; i < staffList.length; i++) {
                let staffEntry = RQService.Tasks.PopulateGetStaffRow(
                    staffList[i]
                );

                console.log('staff item');

                if (staffEntry.StaffID != 0) {
                    this.Staff.push(staffEntry);
                }
            }

            loading.Dismiss();
        });
    }

    public AddNewStaff() {
        if (this.NewStaffName.trim().length < 2) {
            this.ShowAlert(
                 this.ml.Text("CantAddNewStaff"      ,"Can't Add New Staff")
                ,this.ml.Text("StaffNameMustBe"      ,"Staff name must be at least 2 characters")
            );

            return;
        }

        if (this.NewPIN.trim().length < 4) {
            this.ShowAlert(
                 this.ml.Text("CantAddNewStaff"      ,"Can't Add New Staff")
                ,this.ml.Text("PINMustBe"            ,"PIN must be at least 4 characters")
            );

            return;
        }

        if (this.NewPIN.trim() != this.ConfirmNewPIN.trim()) {
            this.ShowAlert(
                 this.ml.Text("CantAddNewStaff"      ,"Can't Add New Staff")
                ,this.ml.Text("PINAndReConfirmedPIN" ,"PIN and re-confirmed PIN do not match")
            );

            return;
        }

        let newStaffParams = RQParam.TasksNewStaffParams();

        newStaffParams.HotelID   = this.Hotel.HotelID;
        newStaffParams.StaffName = this.NewStaffName;
        newStaffParams.PIN       = this.NewPIN;
        newStaffParams.UserID    = 1;
        newStaffParams.LangID    = this.LangID;

        let loading: dmLoading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        RQService.Tasks.NewStaff(newStaffParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) {
                loading.Dismiss();

                return;
            }

            this.NewStaffName  = '';
            this.NewPIN        = '';
            this.ConfirmNewPIN = '';

            loading.Dismiss();

            this.refreshStaff();
        });
    }

    public DeleteStaff(pStaff: RQService.Tasks.GetStaffRow) {
        let deleteStaffParams = RQParam.TasksDeleteStaffParams();

        deleteStaffParams.HotelID = this.Hotel.HotelID;
        deleteStaffParams.StaffID = pStaff.StaffID;
        deleteStaffParams.LangID  = this.LangID;

        let loading: dmLoading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        RQService.Tasks.DeleteStaff(deleteStaffParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) {
                loading.Dismiss();

                return;
            }

            loading.Dismiss();

            this.refreshStaff();
        });
    }

    public ChangePIN(pStaff: RQService.Tasks.GetStaffRow) {
        this.ShowChangePIN(pStaff);
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/xv-staff.ts